import { IRecommendedPackagesState } from '../../types/reducers/recommendedPackages';
import { TActions } from '../../types/actions';
import { LOAD_PUBLISH_TERMS_SUCCESS } from '../../redux/reducers';
import { SET_SELECTED_RECOMMENDED_PACKAGE_ID } from '../../actions/recommendedPackages';

import { defaultState } from './defaultState';

export const recommendedPackages = (
  state: IRecommendedPackagesState = defaultState,
  action: TActions,
): IRecommendedPackagesState => {
  switch (action.type) {
    case LOAD_PUBLISH_TERMS_SUCCESS:
      return { ...state, packages: action.payload.recommendedPackages };

    case SET_SELECTED_RECOMMENDED_PACKAGE_ID:
      return { ...state, selectedPackageId: action.payload };

    default:
      return state;
  }
};
